import { render, staticRenderFns } from "./CardImageSquare.vue?vue&type=template&id=21fc4823"
import script from "./CardImageSquare.vue?vue&type=script&lang=js"
export * from "./CardImageSquare.vue?vue&type=script&lang=js"
import style0 from "./CardImageSquare.vue?vue&type=style&index=0&id=21fc4823&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports